import { render, staticRenderFns } from "./AboutPlatform.vue?vue&type=template&id=5c16f9dd&scoped=true&"
import script from "./AboutPlatform.vue?vue&type=script&lang=js&"
export * from "./AboutPlatform.vue?vue&type=script&lang=js&"
import style0 from "./AboutPlatform.vue?vue&type=style&index=0&id=5c16f9dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16f9dd",
  null
  
)

export default component.exports